import { Component, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { MaterialModule } from './material/material.module';
import { ToolbarComponent } from './components/toolbar/toolbar.component';
import { SideNavigationComponent } from './components/side-navigation/side-navigation.component';
import { BreakpointObserver } from '@angular/cdk/layout';
import { MatSidenav } from '@angular/material/sidenav';
import { AuthService } from './services/auth.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet, ToolbarComponent, SideNavigationComponent, MaterialModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'na-web-tracer';
  opened:boolean = true;
  @ViewChild('sidenav') sidenav!: MatSidenav;

  constructor(
    public authService: AuthService, 
    private breakpointObserver: BreakpointObserver
  ) {
      this.breakpointObserver.observe(['(max-width: 768px)']).subscribe(result => {
        this.opened = !result.matches;
        this.sidenav.mode = result.matches ? 'over' : 'side'; // Set mode based on screen size
      });
    }

  toggleSidebar() {
    this.sidenav.toggle();
  }

}
